import {api} from '../../../store/api';
import {
    EvotorLoginRequest,
    EmployeeRegistrationRequestBody,
    InnCheckResponseRaw,
    InnCheckResult,
    LoginCheckResponse,
    LoginRequest,
    LoginResponse,
} from './types';
import {CONTENT_TYPE_JSON, CONTENT_TYPE_URLENCODED} from '../../../utils/constants';

export const authApi = api.injectEndpoints({
    endpoints: build => ({
        login: build.mutation<LoginResponse, LoginRequest>({
            query: ({formData}) => ({
                url: '/authorization/login.php',
                method: 'POST',
                body: formData,
                headers: {
                    ...CONTENT_TYPE_URLENCODED,
                },
            })
        }),
        evotorLogin: build.mutation<LoginResponse, EvotorLoginRequest>({
            query: (body) => ({
                url: 'https://apifoodbox.ru/api/v1/user/login',
                method: 'POST',
                body,
                headers: {
                    ...CONTENT_TYPE_JSON,
                },
            }),
        }),
        checkSession: build.query<{ status: boolean }, void>({
            query: () => ({
                url: '/authorization/checkSession.php',
                method: 'GET'
            })
        }),
        innCheck: build.mutation<InnCheckResult, string>({
            query: (inn) => ({
                url: '/registration/innCheck',
                method: 'GET',
                params: {inn},
            }),
            transformResponse: (raw: InnCheckResponseRaw): InnCheckResult => ({
                status: !!raw.status,
                message: raw.message,
                prefix: String(
                    raw.prefix ?? raw.loginPrefix ?? raw.Prefix ?? ''
                ).trim(),
            }),
        }),
        loginCheck: build.mutation<LoginCheckResponse, string>({
            query: (login) => ({
                url: '/registration/loginCheck',
                method: 'GET',
                params: {login},
            }),
        }),
        employeeRegistration: build.mutation<LoginResponse, EmployeeRegistrationRequestBody>({
            query: (body) => ({
                url: '/registration/employeeRegistration',
                method: 'POST',
                body,
                headers: {
                    ...CONTENT_TYPE_JSON,
                },
            }),
        }),
    }), overrideExisting: true
});


export const {
    useLoginMutation,
    useEvotorLoginMutation,
    useCheckSessionQuery,
    useInnCheckMutation,
    useLoginCheckMutation,
    useEmployeeRegistrationMutation,
} = authApi;
